<template>
  <div>
    <PageTitle
      :route="$route"
    />

    <PageRowWrapper>
      <div class="col-sm-12">
        <CommandTypeForm v-if="commandType" :commandType="commandType" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import CommandTypeForm from '@/components/settings/parameters/commandTypes/CommandTypeForm'

  export default {
    name: 'CommandType',
    components: {
      PageTitle,
      PageRowWrapper,
      CommandTypeForm
    },
    computed: {
      ...mapState({
        commandType: state => state.commandtypes.commandTypeById
      })
    },
    methods: {
      ...mapActions('commandtypes', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
